import React from 'react';

class ErrorFallback extends React.Component {
  render(): React.ReactElement {
    return <div>Something went wrong. Please try to reload</div>;
  }
}

export default ErrorFallback;
